function LoginPage({
  email,
  error,
  isSubmitting,
  notice,
  onEmailChange,
  onLogin,
  onPasswordChange,
  password,
  switchToRegister,
}) {
  return (
    <section className="main-panel">
      <div className="login-layout">
        <form className="auth-card" onSubmit={onLogin}>
          <span className="mini-label">Login</span>
          <h1>Log ind på Annoncen</h1>
          <p>Brug din konto til at gemme favoritter, sælge varer og administrere dine annoncer.</p>

          {notice && <p className="status-line notice">{notice}</p>}

          <label>
            Email
            <input
              autoComplete="email"
              onChange={(event) => onEmailChange(event.target.value)}
              placeholder="emma@example.com"
              type="email"
              value={email}
            />
          </label>

          <label>
            Password
            <input
              autoComplete="current-password"
              onChange={(event) => onPasswordChange(event.target.value)}
              placeholder="Din adgangskode"
              type="password"
              value={password}
            />
          </label>

          <button className="primary-action" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Logger ind..." : "Log ind"}
          </button>

          <button className="text-action" onClick={switchToRegister} type="button">
            Opret ny konto
          </button>

          {error && <p className="status-line error">{error}</p>}
        </form>
      </div>
    </section>
  );
}

export default LoginPage;
